export default {
    allFiles: [],
};
